// src/components/RequireAuth.tsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { logError } from '@tools/LogsHandler.tsx';
import { useAppSelector } from '@store/store.tsx';

// Ajusta el selector al slice de tu store que guarda el estado de auth.
// Por ejemplo, supongamos que tu state.auth tiene algo como { isAuthenticated: boolean }
const RequireAuth: React.FC<{
  children: React.ReactElement;
}> = ({ children }) => {
  const { isAuthenticated, status } = useAppSelector((state) => state.auth);
  const location = useLocation();

  // logError('>>>> RequireAuth -> status: ', status, 'isAuthenticated: ', isAuthenticated, 'currentPath: ', location.pathname);

  if (status === 'checking' || status === 'loading') {
    return <Spin />;
  }

  if (!isAuthenticated) {
    const origin = `${location.pathname}${location.search}${location.hash}`;
    const state = { from: location, reason: 'unauthenticated', ts: Date.now() }
    logError('RequireAuth - isAuthenticated: ', isAuthenticated, 'state', state);
    return (
      <Navigate
        to={`/auth/login?from=${encodeURIComponent(origin)}`}
        state={state}
        replace
      />
    );
  }

  return children;
};

export default RequireAuth;
